// Português (Brasil) — full parity with en.ts. Keep acronyms untranslated
// (Caratuva, PIX, KYB, KYC, SWIFT, API, OpenAPI, bps). Marketing tone: você,
// direto ao ponto. Posicionamento vs. concorrentes é QUALITATIVO (modelo, não
// números): nunca invente tarifas/taxas de concorrentes.
const ptBR: Record<string, string> = {
  'app.name': 'Caratuva',
  'locale.label': 'Idioma',

  // SEO / social metadata — por rota. Escrito como copy de campanha: direto,
  // específico e honesto. `meta.ogLocale` é a base compartilhada.
  'meta.ogLocale': 'pt_BR',

  'meta.home.title': 'Caratuva — Receba do exterior, em reais via PIX',
  'meta.home.description':
    'Venda para clientes no exterior e receba em reais via PIX. A Caratuva transforma cobranças internacionais em links de pagamento — tarifa transparente, sem conta lá fora, o dinheiro na sua conta. Feita para quem vende, é freelancer ou exporta do Brasil.',
  'meta.home.social':
    'Receba do exterior, em reais via PIX. Um link de pagamento, tarifa transparente, o dinheiro na sua conta no Brasil. Sem precisar de conta no exterior.',

  'meta.integrators.title': 'Caratuva para plataformas — API de recebíveis internacionais',
  'meta.integrators.description':
    'Integre recebíveis internacionais ao seu produto ou marketplace. A Caratuva oferece payment intents, vendedores conectados, webhooks assinados e um sandbox completo — feita com a API em primeiro lugar e conformidade incluída.',
  'meta.integrators.social':
    'Recebíveis internacionais, feitos com a API em primeiro lugar. Payment intents, vendedores conectados, webhooks e um sandbox completo para plataformas e marketplaces.',

  'meta.pricing.title': 'Preços da Caratuva — uma tarifa transparente, sem surpresas',
  'meta.pricing.description':
    'Preços simples e transparentes, para quem vende e para plataformas. Um percentual do que você liquida, informado de forma clara, com descontos por volume conforme você cresce. O modo de teste é grátis.',
  'meta.pricing.social':
    'Uma tarifa transparente sobre o que você liquida — informada de forma clara, com descontos por volume. Grátis para testar. Preços para quem vende e para plataformas.',

  'meta.affiliates.title': 'Afiliados Caratuva — ganhe por 12 meses em cada indicação',
  'meta.affiliates.description':
    'Compartilhe seu link. Quando alguém que você indicou recebe com a Caratuva, você ganha uma parte da nossa tarifa nos primeiros 12 meses dessa pessoa, direto no seu PIX. Até 20%.',
  'meta.affiliates.social':
    'Indique uma empresa e ganhe uma parte da nossa tarifa durante os 12 primeiros meses dela — até 20%, direto no seu PIX.',

  'meta.privacy.title': 'Política de Privacidade — Caratuva',
  'meta.privacy.description':
    'Como a Caratuva coleta, usa e protege seus dados. Sem pixels de rastreamento, sem redes de anúncios.',

  'meta.terms.title': 'Termos de Serviço — Caratuva',
  'meta.terms.description': 'Os termos que regem o uso da Caratuva.',

  // Nav
  'nav.pricing': 'Preços',
  'nav.integrators': 'Integradores',
  'nav.affiliates': 'Afiliados',
  'nav.docs': 'Documentação',
  'nav.signin': 'Entrar',
  'nav.getStarted': 'Começar agora',
  'nav.getPaidNow': 'Receba agora',
  'nav.home': 'Página inicial da Caratuva',

  // Home — Hero
  'home.hero.eyebrow': 'Para quem vende, é freelancer ou exporta do Brasil',
  'home.hero.headline': 'Receba do exterior. Dinheiro em reais, via PIX.',
  'home.hero.subhead':
    'Venda para clientes no exterior e receba em reais via PIX. Envie um link de pagamento, seu cliente paga por transferência e o dinheiro cai na sua conta — tarifa transparente, sem conta lá fora, nada novo para aprender.',
  'home.hero.cta.primary': 'Receba agora',
  'home.hero.cta.secondary': 'Para plataformas e integradores',
  'home.hero.note':
    'Grátis para começar. Cadastre-se, verifique e envie seu primeiro link em minutos.',

  // Home — Problema (vs. plataformas tradicionais de repasse; qualitativo)
  'home.problem.title': 'Receber do exterior não deveria custar uma fortuna nem uma eternidade.',
  'home.problem.subtitle':
    'Se você vende para fora, o jeito antigo de receber ainda atrapalha a sua vida.',
  'home.problem.slow.title': 'Demora para cair',
  'home.problem.slow.body':
    'Transferências internacionais podem se arrastar por dias entre bancos intermediários antes de o dinheiro cair.',
  'home.problem.spread.title': 'Escondido no spread',
  'home.problem.spread.body':
    'As margens e tarifas de câmbio costumam ficar embutidas na cotação, então você nunca sabe ao certo quanto vai receber.',
  'home.problem.parked.title': 'Parado longe de você',
  'home.problem.parked.body':
    'As plataformas tradicionais deixam seu dinheiro numa conta no exterior até você superar uma série de etapas para trazê-lo ao Brasil.',

  // Home — Como funciona
  'home.how.title': 'Da cobrança aos reais em quatro passos',
  'home.how.subtitle': 'Sem conta no exterior, sem cripto, nada novo para o seu cliente aprender.',
  'home.how.step1.title': 'Cadastre-se',
  'home.how.step1.body': 'Crie sua conta em minutos — sem ligação comercial, sem taxa de adesão.',
  'home.how.step2.title': 'Verifique você ou sua empresa',
  'home.how.step2.body':
    'Confirme sua identidade (ou a da empresa) uma única vez. A conformidade é resolvida para você.',
  'home.how.step3.title': 'Envie um link de pagamento',
  'home.how.step3.body':
    'Crie uma cobrança e compartilhe o link. Seu cliente paga por transferência — nada novo do lado dele.',
  'home.how.step4.title': 'Receba em reais via PIX',
  'home.how.step4.body': 'O dinheiro é liquidado e cai na sua conta bancária no Brasil via PIX.',

  // Home — Por que Caratuva (trust)
  'home.why.title': 'Tudo o que você precisa para receber, e nada além disso.',
  'home.why.subtitle': 'Feita para quem vende para fora e quer receber aqui dentro.',
  'home.why.fee.title': 'Uma tarifa transparente',
  'home.why.fee.body':
    'Você vê a tarifa antes, a cada cobrança liquidada — sem spread de câmbio escondido, sem surpresas.',
  'home.why.pix.title': 'Reais via PIX',
  'home.why.pix.body': 'O valor exato cai na sua conta bancária no Brasil pelo PIX.',
  'home.why.compliance.title': 'Conformidade embutida',
  'home.why.compliance.body':
    'O KYC e o KYB passam por um parceiro licenciado e regulado — a Caratuva nunca custodia seu dinheiro.',
  'home.why.noforeign.title': 'Sem conta no exterior',
  'home.why.noforeign.body':
    'Nada de abrir ou gerenciar conta lá fora. Seu dinheiro vem direto para o Brasil.',

  // Home — Comparação vs. plataformas tradicionais (modelo, não números)
  'home.compare.title': 'Um jeito diferente de receber do exterior',
  'home.compare.subtitle':
    'Comparado às plataformas tradicionais de repasse internacional, como Payoneer ou Deel.',
  'home.compare.them.label': 'Plataformas tradicionais de repasse',
  'home.compare.us.label': 'Com a Caratuva',
  'home.compare.row1.them': 'Seu dinheiro fica numa conta em moeda estrangeira até você sacar.',
  'home.compare.row1.us': 'Você recebe direto na sua conta no Brasil, em reais.',
  'home.compare.row2.them': 'As margens de câmbio costumam ficar embutidas na cotação.',
  'home.compare.row2.us': 'Uma única tarifa, informada antes, a cada cobrança liquidada.',
  'home.compare.row3.them': 'Trazer o dinheiro para casa pode levar dias e cobrar mais uma fatia.',
  'home.compare.row3.us': 'A liquidação paga via PIX, sem uma etapa separada de saque.',
  'home.compare.row4.them': 'Você administra um saldo numa moeda que não é a sua.',
  'home.compare.row4.us': 'Você só envia um link e recebe em reais.',
  'home.compare.note':
    'Uma comparação qualitativa de como os modelos funcionam. Payoneer e Deel são marcas de seus respectivos donos; não citamos as tarifas deles.',

  // Home — Chamada de afiliados
  'home.affiliate.badge': 'Programa de afiliados',
  'home.affiliate.title': 'Conhece outras pessoas que recebem do exterior?',
  'home.affiliate.body':
    'Indique e ganhe uma parte da nossa tarifa durante os 12 primeiros meses de cada indicação — até 20%, direto no seu PIX.',
  'home.affiliate.cta': 'Conhecer o programa',

  // Home — CTA final
  'home.cta.title': 'Pronto para receber em reais?',
  'home.cta.subtitle':
    'Cadastre-se grátis, verifique uma vez e envie seu primeiro link de pagamento hoje.',
  'home.cta.primary': 'Receba agora',
  'home.cta.secondary': 'Para plataformas e integradores',

  // Footer
  'footer.tagline': 'Receba do exterior. Dinheiro em reais, via PIX.',
  'footer.product': 'Produto',
  'footer.getPaid': 'Receba agora',
  'footer.pricing': 'Preços',
  'footer.integrators': 'Integradores',
  'footer.docs': 'Documentação',
  'footer.dashboard': 'Dashboard',
  'footer.company': 'Empresa',
  'footer.contact': 'Falar com vendas',
  'footer.privacy': 'Política de Privacidade',
  'footer.terms': 'Termos de Serviço',
  'footer.rights':
    '© {year} Caratuva — um produto da Pavezi Software LTDA. Todos os direitos reservados.',

  // Páginas legais
  'legal.effectiveDate': 'Data de vigência',

  // Página de integradores
  'integrators.eyebrow': 'Para plataformas e integradores',
  'integrators.title': 'Integre recebíveis internacionais ao seu produto.',
  'integrators.subtitle':
    'Plataformas, marketplaces e empresas de software usam a Caratuva para que seus vendedores recebam do exterior — payment intents, vendedores conectados, webhooks e um sandbox completo, tudo com a API em primeiro lugar.',
  'integrators.cta.primary': 'Comece no sandbox',
  'integrators.cta.secondary': 'Ver a documentação',

  'integrators.caps.title': 'Os blocos que você integra',
  'integrators.caps.subtitle':
    'Tudo o que há no dashboard está na API — conecte aos seus próprios fluxos.',
  'integrators.caps.intents.title': 'Payment intents',
  'integrators.caps.intents.body':
    'Crie um payment intent por cobrança e receba dos compradores por transferência bancária.',
  'integrators.caps.sellers.title': 'Vendedores conectados',
  'integrators.caps.sellers.body':
    'Cadastre seus vendedores como contas conectadas e pague cada um deles na própria conta bancária.',
  'integrators.caps.webhooks.title': 'Webhooks assinados',
  'integrators.caps.webhooks.body':
    'Receba um webhook assinado a cada evento do ciclo de vida do pagamento para manter seus sistemas em sincronia.',
  'integrators.caps.compliance.title': 'Conformidade incluída',
  'integrators.caps.compliance.body':
    'O KYB e o KYC passam pelo nosso parceiro licenciado, então a verificação não é problema seu para construir.',

  'integrators.dev.title': 'Feito com a API em primeiro lugar.',
  'integrators.dev.subtitle':
    'Integre faturas, pagamentos e webhooks diretamente. Tudo o que você faz no dashboard, você faz na API.',
  'integrators.dev.point.keys':
    'Chaves pk_test e pk_live separadas mantêm teste e produção bem isolados.',
  'integrators.dev.point.webhooks':
    'Webhooks assinados para cada evento do ciclo de vida do pagamento.',
  'integrators.dev.point.openapi': 'Uma referência OpenAPI completa com playground interativo.',
  'integrators.dev.cta': 'Explorar a documentação da API',
  'integrators.dev.snippet.caption': 'Criar um payment intent',

  'integrators.modes.title':
    'Teste o fluxo completo de graça. Vá para produção quando estiver pronto.',
  'integrators.modes.sandbox.title': 'Modo de teste',
  'integrators.modes.sandbox.badge': 'Self-service',
  'integrators.modes.sandbox.item1': 'Cadastre-se e comece em minutos — sem ligação comercial.',
  'integrators.modes.sandbox.item2': 'Chaves de API de teste (pk_test) e faturas em modo de teste.',
  'integrators.modes.sandbox.item3':
    'Rode o fluxo de pagamento completo, de ponta a ponta, em rede de teste.',
  'integrators.modes.sandbox.cta': 'Comece no sandbox',
  'integrators.modes.production.title': 'Produção',
  'integrators.modes.production.badge': 'Fale com a gente',
  'integrators.modes.production.item1':
    'O acesso à produção exige uma conversa rápida com nosso time.',
  'integrators.modes.production.item2':
    'Verificação da empresa (KYB) pelo nosso parceiro licenciado.',
  'integrators.modes.production.item3':
    'Após a aprovação, mude para o modo live e movimente dinheiro de verdade.',
  'integrators.modes.production.cta': 'Falar com vendas',

  'integrators.ctaband.title': 'Coloque pagamentos internacionais na sua plataforma.',
  'integrators.ctaband.subtitle':
    'Comece no sandbox hoje. Fale com a gente quando estiver pronto para a produção.',
  'integrators.ctaband.primary': 'Comece no sandbox',
  'integrators.ctaband.secondary': 'Falar com vendas',

  // Pricing page
  'pricing.eyebrow': 'Preços',
  'pricing.title': 'Preços simples e transparentes.',
  'pricing.subtitle':
    'Um percentual do que você movimenta — informado antes, com descontos conforme você cresce.',

  // Pricing — Receba (vendedores)
  'pricing.sellers.title': 'Receba',
  'pricing.sellers.note':
    'Cadastre-se, verifique uma vez e envie links de pagamento. Você vê a tarifa a cada cobrança liquidada — sem taxa mensal, sem spread de câmbio escondido.',
  'pricing.sellers.cta': 'Receba agora',
  'pricing.sellers.referralDiscount':
    'Chegou pelo link de um parceiro? Você ganha 50% de desconto na nossa tarifa nos seus primeiros 30 dias.',

  'pricing.fee.title': 'Tarifa por transação',
  'pricing.fee.amount': 'a partir de 2%',
  'pricing.fee.unit': '(200 bps) por fatura liquidada',
  'pricing.fee.body': 'Descontos por volume e por negociação disponíveis conforme você escala.',
  'pricing.getpaid.title': 'Para começar',
  'pricing.getpaid.amount': 'Sem custo',
  'pricing.getpaid.body': 'Sem taxa mensal e sem taxa de adesão — você só paga quando recebe.',
  'pricing.monthly.title': 'Taxa mensal',
  'pricing.monthly.amount': 'Falar com vendas',
  'pricing.monthly.body':
    'Cobre o acesso à plataforma, a conformidade contínua e o suporte à integração.',
  'pricing.sandbox.title': 'Modo de teste',
  'pricing.sandbox.amount': 'Sem custo',
  'pricing.sandbox.body': 'Teste completo, de ponta a ponta, em rede de teste, sem compromisso.',

  // Pricing — Plataformas e integradores
  'pricing.integrators.eyebrow': 'Plataformas e integradores',
  'pricing.integrators.title': 'Preços que escalam com a sua plataforma.',
  'pricing.integrators.subtitle':
    'A mesma tarifa transparente, com tarifas por volume e um plano mensal para plataformas que integram a Caratuva.',
  'pricing.integrators.cta.primary': 'Comece no sandbox',
  'pricing.integrators.cta.secondary': 'Falar com vendas',

  'pricing.tiers.title': 'Tarifas por volume',
  'pricing.tiers.col.volume': 'Volume mensal',
  'pricing.tiers.col.fee': 'Tarifa por transação',
  'pricing.tiers.row1.volume': 'Até US$ 100 mil',
  'pricing.tiers.row1.fee': '2,0%',
  'pricing.tiers.row2.volume': 'US$ 100 mil – US$ 1 mi',
  'pricing.tiers.row2.fee': '1,5%',
  'pricing.tiers.row3.volume': 'US$ 1 mi – US$ 10 mi',
  'pricing.tiers.row3.fee': '1,0%',
  'pricing.tiers.row4.volume': 'US$ 10 mi+',
  'pricing.tiers.row4.fee': '0,75%',
  'pricing.tiers.note':
    'A tarifa incide sobre o seu volume liquidado total no mês, somando todas as faturas.',
  'pricing.compare.title': 'Como se compara',
  'pricing.compare.col.feature': '',
  'pricing.compare.col.caratuva': 'Caratuva',
  'pricing.compare.col.bank': 'Banco tradicional / SWIFT',
  'pricing.compare.row.speed': 'Tempo de liquidação',
  'pricing.compare.speed.caratuva': 'Minutos',
  'pricing.compare.speed.bank': '2 a 5 dias úteis',
  'pricing.compare.row.cost': 'Custo total',
  'pricing.compare.cost.caratuva': 'A partir de ~2%',
  'pricing.compare.cost.bank': '~3% a 7%',
  'pricing.compare.row.cambio': 'Burocracia de câmbio',
  'pricing.compare.cambio.caratuva': 'Resolvida para você',
  'pricing.compare.cambio.bank': 'Manual, a cada operação',
  'pricing.compare.row.payout': 'Pagamento',
  'pricing.compare.payout.caratuva': 'PIX em reais',
  'pricing.compare.payout.bank': 'Transferência (wire)',
  'pricing.note':
    'A tarifa final, os descontos e a taxa mensal são acordados no onboarding, com base no seu volume e corredores.',
  'pricing.cta.title': 'Pronto para começar?',
  'pricing.cta.primary': 'Receba agora',
  'pricing.cta.secondary': 'Comece no sandbox',

  // Página de afiliados
  'affiliates.eyebrow': 'Programa de afiliados',
  'affiliates.title': 'Ganhe uma parte de cada cliente que você indicar por 12 meses.',
  'affiliates.subtitle':
    'Compartilhe seu link. Quando alguém indicado por você recebe com a Caratuva, você ganha uma parte da nossa tarifa durante os 12 primeiros meses dessa pessoa, paga direto no seu PIX.',
  'affiliates.perk.title': 'Seu link vale alguma coisa',
  'affiliates.perk.body':
    'Quem se cadastra por ele ganha 50% de desconto na nossa tarifa no primeiro mês.',
  'affiliates.how.step1.title': 'Compartilhe seu link',
  'affiliates.how.step1.body':
    'Envie seu link de indicação único para qualquer pessoa que venda ou receba em operações internacionais.',
  'affiliates.how.step2.title': 'Ela recebe com a Caratuva',
  'affiliates.how.step2.body':
    'Assim que ela se cadastra e liquida pagamentos pela Caratuva, você ganha sobre tudo o que ela movimentar nos primeiros 12 meses.',
  'affiliates.how.step3.title': 'Você recebe via PIX',
  'affiliates.how.step3.body':
    'Você ganha uma parte da nossa tarifa em cada pagamento que ela fizer — mais volume indicado por mês libera uma parte maior.',
  'affiliates.tiers.title': 'Sua parte cresce com o volume indicado',
  'affiliates.tiers.subtitle': 'Um percentual da tarifa que a Caratuva recebe — limitado a 20%.',
  'affiliates.tiers.col.volume': 'Volume indicado mensal',
  'affiliates.tiers.col.share': 'Sua parte da nossa tarifa',
  'affiliates.tiers.row1.volume': 'Até US$ 100 mil',
  'affiliates.tiers.row1.share': '5%',
  'affiliates.tiers.row2.volume': 'US$ 100 mil – US$ 1 mi',
  'affiliates.tiers.row2.share': '10%',
  'affiliates.tiers.row3.volume': 'US$ 1 mi – US$ 10 mi',
  'affiliates.tiers.row3.share': '15%',
  'affiliates.tiers.row4.volume': 'US$ 10 mi+',
  'affiliates.tiers.row4.share': '20%',
  'affiliates.tiers.note':
    'A parte incide sobre o volume mensal combinado dos clientes que você indicou, somando todas as faturas deles. Limitada a 20% da nossa tarifa.',
  'affiliates.calculator.heading': 'Estime seus ganhos mensais',
  'affiliates.calculator.title': 'Calculadora de ganhos',
  'affiliates.calculator.subtitle':
    'Arraste o controle deslizante ou informe um volume indicado mensal esperado para ver quanto você poderia ganhar.',
  'affiliates.calculator.volumeLabel': 'Volume indicado mensal esperado (US$)',
  'affiliates.calculator.result.fee': 'Tarifa da Caratuva',
  'affiliates.calculator.result.share': 'Sua parte',
  'affiliates.calculator.result.earnings': 'Seus ganhos',
  'affiliates.calculator.result.perMonth': 'por mês',
  'affiliates.calculator.disclaimer':
    'Apenas uma estimativa — as taxas reais podem variar e são confirmadas quando você se torna um afiliado.',
  'affiliates.cta.title': 'Pronto para começar a ganhar?',
  'affiliates.cta.subtitle': 'Entre na Caratuva para pegar seu link de indicação.',
  'affiliates.cta.primary': 'Pegar meu link de indicação',

  // Modal de contato com vendas
  'sales.title': 'Falar com vendas',
  'sales.subtitle': 'Conte sobre a sua empresa e entraremos em contato para levar você à produção.',
  'sales.form.company': 'Nome da empresa',
  'sales.form.name': 'Seu nome',
  'sales.form.email': 'E-mail corporativo',
  'sales.form.phone': 'Telefone (opcional)',
  'sales.form.message': 'O que você precisa? (opcional)',
  'sales.form.submit': 'Enviar para vendas',
  'sales.form.submitting': 'Enviando…',
  'sales.form.privacy': 'Usaremos seus dados apenas para retornar o contato sobre a Caratuva.',
  'sales.success.title': 'Recebemos, obrigado',
  'sales.success.body': 'Nossa equipe entrará em contato em breve pelo e-mail informado.',
  'sales.success.close': 'Fechar',

  // Botão flutuante do WhatsApp
  'whatsapp.aria': 'Fale com a gente no WhatsApp',
};
export default ptBR;
